import { render, staticRenderFns } from "./Generate.vue?vue&type=template&id=5dcfae72&scoped=true&"
import script from "./Generate.vue?vue&type=script&lang=js&"
export * from "./Generate.vue?vue&type=script&lang=js&"
import style0 from "./Generate.vue?vue&type=style&index=0&id=5dcfae72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcfae72",
  null
  
)

export default component.exports